// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"1fea5ebe","543":"e0b879ab"}[chunkId] + ".chunk.js";
};